// import React, { useState, useEffect } from "react";
// import {
//   Typography,
//   Box,
//   Button,
//   Breadcrumbs,
//   Link as MUILink,
//   CircularProgress,
//   Grid,
// } from "@mui/material";
// import { Link } from "react-router-dom";
// import { message } from "antd";
// import imageCompression from "browser-image-compression";
// import { styled } from "@mui/material/styles";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   uploadHomeBanner,
//   fetchHomeBanners,
//   deleteHomeBanner,
// } from "../../redux/actions/admin/homeBannerActions";
// import PageTitle from "../../Components/PageTitle";

// const HomeBanner = () => {
//   const [images, setImages] = useState([]);
//   const [imageBase64List, setImageBase64List] = useState([]);

//   const dispatch = useDispatch();
//   const { loading, images: uploadedImages } = useSelector(
//     (state) => state.homeBanner
//   );

//   useEffect(() => {
//     dispatch(fetchHomeBanners());
//   }, [dispatch]);

//   const VisuallyHiddenInput = styled("input")({
//     display: "none",
//   });

//   const handleImageUpload = async (event) => {
//     const files = event.target.files;
//     if (!files || files.length === 0) return;

//     const maxSizeInMB = 5;
//     const base64Images = [];

//     try {
//       const promises = Array.from(files).map(async (file) => {
//         if (file.size / (1024 * 1024) > maxSizeInMB) {
//           message.error(`Image size should not exceed ${maxSizeInMB} MB.`);
//           return null;
//         }

//         const options = {
//           maxSizeMB: 1,
//           maxWidthOrHeight: 800,
//           useWebWorker: true,
//         };

//         const compressedFile = await imageCompression(file, options);
//         const reader = new FileReader();

//         return new Promise((resolve) => {
//           reader.onloadend = () => {
//             let imageBase64 = reader.result;
//             if (imageBase64.includes("base64,")) {
//               base64Images.push(imageBase64.split("base64,")[1]);
//             }
//             resolve(imageBase64);
//           };
//           reader.readAsDataURL(compressedFile);
//         });
//       });

//       const compressedImages = await Promise.all(promises);
//       setImages(compressedImages.filter(Boolean));
//       setImageBase64List(base64Images);
//     } catch (error) {
//       console.error("Error compressing images:", error);
//     }
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();
//     if (imageBase64List.length === 0) {
//       message.error("Please upload at least one image.");
//       return;
//     }
//     dispatch(uploadHomeBanner(imageBase64List)).then(() => {
//       setImages([]);
//       setImageBase64List([]);
//       dispatch(fetchHomeBanners());
//     });
//   };

//   const handleDelete = (publicId) => {
//     if (!publicId) return;
//     dispatch(deleteHomeBanner(publicId)).then(() => {
//       dispatch(fetchHomeBanners());
//     });
//   };

//   return (
//     <>
//       <PageTitle
//         title="Manage Home Banner Images  - Admin Panel | Shree Mangalam School"
//         description="Upload, update, and manage home banner images for the official website of Shree Mangalam School. Keep your homepage visually engaging and informative."
//         url="/admin/institute/home"
//         keywords="home banner images, website banner management, Shree Manglam homepage banners, upload school banners, admin banner control"
//       />

//       <Typography
//         variant="h5"
//         align="center"
//         gutterBottom
//         sx={{
//           mb: 3,
//           fontFamily: "Poppins, sans-serif",
//           color: "#2C3E50",
//           letterSpacing: "2.5px",
//           lineHeight: 1.8,
//         }}
//       >
//         Home Banner Images
//       </Typography>

//       <Breadcrumbs
//         aria-label="breadcrumb"
//         sx={{
//           mb: 5,
//           backgroundColor: "#fff",
//           padding: "20px",
//           borderRadius: "12px",
//           boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
//         }}
//       >
//         <MUILink
//           component={Link}
//           to="/dashboard"
//           sx={{ color: "inherit", textDecoration: "none" }}
//         >
//           Dashboard
//         </MUILink>
//         <Typography sx={{ color: "primary.main" }}>Home Banner</Typography>
//       </Breadcrumbs>

//       <Box component="form" onSubmit={handleSubmit}>
//         <VisuallyHiddenInput
//           accept="image/*"
//           id="contained-button-file"
//           type="file"
//           multiple
//           onChange={handleImageUpload}
//         />
//         <label htmlFor="contained-button-file">
//           <Button
//             variant="outlined"
//             color="primary"
//             component="span"
//             startIcon={<CloudUploadIcon />}
//             sx={{
//               mb: 3,
//               textTransform: "none",
//               fontFamily: "Poppins, sans-serif",
//               fontWeight: 500,
//             }}
//           >
//             Upload Banner Images
//           </Button>
//         </label>

//         {images.length > 0 && (
//           <Grid container spacing={2}>
//             {images.map((image, index) => (
//               <Grid item key={index}>
//                 <img
//                   src={image}
//                   alt={`banner-preview-${index}`}
//                   style={{
//                     height: "100px",
//                     width: "100px",
//                     borderRadius: "8px",
//                     objectFit: "cover",
//                   }}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         )}

//         <Box>
//           <Button
//             variant="contained"
//             type="submit"
//             disabled={loading}
//             sx={{
//               mb: 5,
//               mt: 2,
//               textTransform: "none",
//               fontFamily: "Poppins, sans-serif",
//               fontWeight: 500,
//             }}
//           >
//             {loading ? <CircularProgress size={24} /> : "Add Banner Image"}
//           </Button>
//         </Box>

//         <hr />
//         <Typography
//           variant="h6"
//           sx={{
//             // pb: 2,
//             // pt: 3,
//             fontFamily: "Poppins, sans-serif",
//             color: "#555",
//             letterSpacing: "2.5px",
//           }}
//         >
//           All Banner Images
//         </Typography>

//         <Grid container spacing={2} mt={3} mb={5}>
//           {uploadedImages &&
//             uploadedImages.map((image, index) => (
//               <Grid
//                 container
//                 item
//                 key={index}
//                 alignItems="center"
//                 sx={{ mr: { md: 2, xs: 2 }, ml: { md: 0, xs: 2 } }}
//               >
//                 <Grid item md={1.8} sm={12} xs={12}>
//                   <Button
//                     variant="outlined"
//                     className="courses_desc"
//                     color="error"
//                     sx={{
//                       mt: 1,
//                       mb: 3,
//                       // ml: 2,
//                       borderRadius: "50px",
//                       textTransform: "none",
//                       fontFamily: "Poppins, sans-serif",
//                       letterSpacing: ".1rem",
//                     }}
//                     onClick={() => handleDelete(image.publicId)}
//                   >
//                     {loading ? <CircularProgress size={24} /> : "Delete "}
//                   </Button>
//                 </Grid>
//                 <Grid
//                   item
//                   md={10.2}
//                   sm={12}
//                   xs={12}
//                   sx={{
//                     transition: "transform 0.3s ease-in-out",
//                     "&:hover": {
//                       transform: "scale(1.02)",
//                     },
//                     borderRadius: "8px",
//                     overflow: "hidden",
//                     boxShadow: 3,
//                   }}
//                 >
//                   <img
//                     src={image.imageUrl}
//                     alt={`uploaded-banner-${index}`}
//                     style={{
//                       // marginLeft: "-1%",
//                       height: "300px",
//                       width: "100%",
//                       borderRadius: "8px",
//                       objectFit: "cover",
//                     }}
//                   />
//                 </Grid>
//               </Grid>
//             ))}
//         </Grid>
//       </Box>
//     </>
//   );
// };

// export default HomeBanner;

import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  Breadcrumbs,
  Link as MUILink,
  CircularProgress,
  Grid,
  Pagination,
  Stack,
} from "@mui/material";
import { Link } from "react-router-dom";
import { message } from "antd";
import imageCompression from "browser-image-compression";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadHomeBanner,
  fetchHomeBanners,
  deleteHomeBanner,
} from "../../redux/actions/admin/homeBannerActions";
import PageTitle from "../../Components/PageTitle";

const HomeBanner = () => {
  const [images, setImages] = useState([]);
  const [imageBase64List, setImageBase64List] = useState([]);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6); // प्रति page में images की संख्या

  const dispatch = useDispatch();
  const { loading, images: uploadedImages } = useSelector(
    (state) => state.homeBanner
  );

  useEffect(() => {
    dispatch(fetchHomeBanners());
  }, [dispatch]);

  // Pagination calculations
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = uploadedImages?.slice(indexOfFirstItem, indexOfLastItem) || [];
  const totalPages = Math.ceil((uploadedImages?.length || 0) / itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const VisuallyHiddenInput = styled("input")({
    display: "none",
  });

  const handleImageUpload = async (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const maxSizeInMB = 5;
    const base64Images = [];

    try {
      const promises = Array.from(files).map(async (file) => {
        if (file.size / (1024 * 1024) > maxSizeInMB) {
          message.error(`Image size should not exceed ${maxSizeInMB} MB.`);
          return null;
        }

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 800,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        const reader = new FileReader();

        return new Promise((resolve) => {
          reader.onloadend = () => {
            let imageBase64 = reader.result;
            if (imageBase64.includes("base64,")) {
              base64Images.push(imageBase64.split("base64,")[1]);
            }
            resolve(imageBase64);
          };
          reader.readAsDataURL(compressedFile);
        });
      });

      const compressedImages = await Promise.all(promises);
      setImages(compressedImages.filter(Boolean));
      setImageBase64List(base64Images);
    } catch (error) {
      console.error("Error compressing images:", error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (imageBase64List.length === 0) {
      message.error("Please upload at least one image.");
      return;
    }
    dispatch(uploadHomeBanner(imageBase64List)).then(() => {
      setImages([]);
      setImageBase64List([]);
      setCurrentPage(1); // नई image upload करने पर first page पर redirect करें
      dispatch(fetchHomeBanners());
    });
  };

  const handleDelete = (publicId) => {
    if (!publicId) return;
    dispatch(deleteHomeBanner(publicId)).then(() => {
      // अगर current page खाली हो जाती है तो previous page पर जाएँ
      if (currentItems.length === 1 && currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
      dispatch(fetchHomeBanners());
    });
  };

  return (
    <>
      <PageTitle
        title="Manage Home Banner Images  - Admin Panel | Shree Mangalam School"
        description="Upload, update, and manage home banner images for the official website of Shree Mangalam School. Keep your homepage visually engaging and informative."
        url="/admin/institute/home"
        keywords="home banner images, website banner management, Shree Manglam homepage banners, upload school banners, admin banner control"
      />

      <Typography
        variant="h5"
        align="center"
        gutterBottom
        sx={{
          mb: 3,
          fontFamily: "Poppins, sans-serif",
          color: "#2C3E50",
          letterSpacing: "2.5px",
          lineHeight: 1.8,
        }}
      >
        Home Banner Images
      </Typography>

      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          mb: 5,
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        }}
      >
        <MUILink
          component={Link}
          to="/dashboard"
          sx={{ color: "inherit", textDecoration: "none" }}
        >
          Dashboard
        </MUILink>
        <Typography sx={{ color: "primary.main" }}>Home Banner</Typography>
      </Breadcrumbs>

      <Box component="form" onSubmit={handleSubmit}>
        <VisuallyHiddenInput
          accept="image/*"
          id="contained-button-file"
          type="file"
          multiple
          onChange={handleImageUpload}
        />
        <label htmlFor="contained-button-file">
          <Button
            variant="outlined"
            color="primary"
            component="span"
            startIcon={<CloudUploadIcon />}
            sx={{
              mb: 3,
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
            }}
          >
            Upload Banner Images
          </Button>
        </label>

        {images.length > 0 && (
          <Grid container spacing={2}>
            {images.map((image, index) => (
              <Grid item key={index}>
                <img
                  src={image}
                  alt={`banner-preview-${index}`}
                  style={{
                    height: "100px",
                    width: "100px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
              </Grid>
            ))}
          </Grid>
        )}

        <Box>
          <Button
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              mb: 5,
              mt: 2,
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              fontWeight: 500,
            }}
          >
            {loading ? <CircularProgress size={24} /> : "Add Banner Image"}
          </Button>
        </Box>

        <hr />
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Poppins, sans-serif",
              color: "#555",
              letterSpacing: "2.5px",
            }}
          >
            All Banner Images
          </Typography>
          
          {uploadedImages?.length > 0 && (
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Poppins, sans-serif",
                color: "#666",
              }}
            >
              Showing {indexOfFirstItem + 1}-{Math.min(indexOfLastItem, uploadedImages.length)} of {uploadedImages.length} images
            </Typography>
          )}
        </Box>

        <Grid container spacing={2} mt={3} mb={5}>
          {currentItems.length > 0 ? (
            currentItems.map((image, index) => (
              <Grid
                container
                item
                key={index}
                alignItems="center"
                sx={{ mr: { md: 2, xs: 2 }, ml: { md: 0, xs: 2 } }}
              >
                <Grid item md={1.8} sm={12} xs={12}>
                  <Button
                    variant="outlined"
                    className="courses_desc"
                    color="error"
                    sx={{
                      mt: 1,
                      mb: 3,
                      borderRadius: "50px",
                      textTransform: "none",
                      fontFamily: "Poppins, sans-serif",
                      letterSpacing: ".1rem",
                    }}
                    onClick={() => handleDelete(image.publicId)}
                  >
                    {loading ? <CircularProgress size={24} /> : "Delete "}
                  </Button>
                </Grid>
                <Grid
                  item
                  md={10.2}
                  sm={12}
                  xs={12}
                  sx={{
                    transition: "transform 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                    borderRadius: "8px",
                    overflow: "hidden",
                    boxShadow: 3,
                  }}
                >
                  <img
                    src={image.imageUrl}
                    alt={`uploaded-banner-${index}`}
                    style={{
                      height: "300px",
                      width: "100%",
                      borderRadius: "8px",
                      objectFit: "cover",
                    }}
                  />
                </Grid>
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography
                variant="body1"
                align="center"
                sx={{
                  py: 5,
                  fontFamily: "Poppins, sans-serif",
                  color: "#999",
                }}
              >
                No banner images found. Upload some images to get started.
              </Typography>
            </Grid>
          )}
        </Grid>

        {/* Pagination Component */}
        {totalPages > 1 && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4, mb: 5 }}>
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size="large"
                showFirstButton
                showLastButton
                sx={{
                  "& .MuiPaginationItem-root": {
                    fontFamily: "Poppins, sans-serif",
                  },
                }}
              />
            </Stack>
          </Box>
        )}
      </Box>
    </>
  );
};

export default HomeBanner;